<div class="clearfix clsAcknowledgementPage">
    <div class="clsInnerBlock">
        <div class="clsInnerSection">
            <!-- Header -->
            <div class="clsGradient">


                <h1>Confidentiality Acknowledgment</h1>
                <p>Protecting Sensitive Information is Our Shared Responsibility</p>
            </div>

            <!-- Content -->
            <div class="clearfix clsContentSection">
                <!-- Introduction -->
                <div class="clearfix clsFirstContent mb-4">
                    <p>
                       Warning! This system contains U.S. Government information. By using this information system, you are
                        consenting to system monitoring for law enforcement and other purposes. Unauthorized or improper use of, or access to,
                        this computer system may subject you to state and federal criminal prosecution and penalties as well as civil penalties.
                        At any time, the government may intercept, search, and seize any communication or data transiting or stored on this
                        information system.
                    </p>
                </div>

             
                <!-- Certification Statement -->
                <div class="clearfix clsAgreementContent">
                    <p>
                        By proceeding, I certify that I have read, understood, and agree to abide by this
                        confidentiality agreement.
                    </p>
                </div>

                <!-- Acknowledgment Checkbox -->
                <div class="clearfix clsCheckBoxContent">
                    <input type="checkbox" id="acknowledgment" (change)="toggleButton()"  [(ngModel)]="checked">
                    <label for="acknowledgment">
                        I acknowledge and agree to the above terms.
                    </label>
                </div>

                <!-- Continue Button -->
                <div class="d-flex justify-content-center pt-4">
                    <button id="continueBtn" (click)="handleContinue()" class="btn btn-primary btn-lg" disabled>
                        <em *ngIf="submitStatus ==='Please wait ...'" class="fa fa-spinner fa-spin me-2"></em> {{ submitStatus }}
                    </button>
                </div>

                <!-- Footer -->
                <div class="clearfix text-center pt-4 mt-4 sep-top">
                    <p class="no-mar">
                        This acknowledgment is required to access the system and protect sensitive information.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>